export default function Footer() {
  return (
    <footer id="footer" className="bg-foreground-950 text-background-50/70">
      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="sm:col-span-2 lg:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-play-circle-fill text-background-50 text-lg"></i>
              </div>
              <span className="font-heading text-lg text-background-50">榴莲视频</span>
            </div>
            <p className="text-xs leading-relaxed text-background-50/50 mb-4 max-w-xs">
              榴莲视频聚合香蕉视频、红桃视频、91视频、蜜桃视频、樱花视频等主流品牌高清资源，
              提供免费在线高清视频观看服务，每日更新数百部精选内容，是您身边的视频大全平台。
            </p>
            <div className="flex items-center gap-3">
              <div className="w-8 h-8 rounded-full bg-background-50/10 flex items-center justify-center hover:bg-primary-500/80 transition-colors duration-200 cursor-pointer">
                <i className="ri-weibo-line text-sm text-background-50/70"></i>
              </div>
              <div className="w-8 h-8 rounded-full bg-background-50/10 flex items-center justify-center hover:bg-primary-500/80 transition-colors duration-200 cursor-pointer">
                <i className="ri-wechat-line text-sm text-background-50/70"></i>
              </div>
              <div className="w-8 h-8 rounded-full bg-background-50/10 flex items-center justify-center hover:bg-primary-500/80 transition-colors duration-200 cursor-pointer">
                <i className="ri-bilibili-line text-sm text-background-50/70"></i>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-medium text-background-50 text-sm mb-4">快速导航</h3>
            <div className="space-y-2.5">
              <a href="#hero" className="block text-xs text-background-50/50 hover:text-primary-400 transition-colors duration-150 whitespace-nowrap cursor-pointer">首页</a>
              <a href="#about" className="block text-xs text-background-50/50 hover:text-primary-400 transition-colors duration-150 whitespace-nowrap cursor-pointer">关于我们</a>
              <a href="#app" className="block text-xs text-background-50/50 hover:text-primary-400 transition-colors duration-150 whitespace-nowrap cursor-pointer">APP下载</a>
              <a href="#faq" className="block text-xs text-background-50/50 hover:text-primary-400 transition-colors duration-150 whitespace-nowrap cursor-pointer">常见问题</a>
              <a href="#contact" className="block text-xs text-background-50/50 hover:text-primary-400 transition-colors duration-150 whitespace-nowrap cursor-pointer">联系我们</a>
            </div>
          </div>

          {/* Content */}
          <div>
            <h3 className="font-medium text-background-50 text-sm mb-4">内容分类</h3>
            <div className="space-y-2.5">
              <a href="#index" className="block text-xs text-background-50/50 hover:text-primary-400 transition-colors duration-150 whitespace-nowrap cursor-pointer">影视剧场</a>
              <a href="#index" className="block text-xs text-background-50/50 hover:text-primary-400 transition-colors duration-150 whitespace-nowrap cursor-pointer">综艺娱乐</a>
              <a href="#index" className="block text-xs text-background-50/50 hover:text-primary-400 transition-colors duration-150 whitespace-nowrap cursor-pointer">动漫专区</a>
              <a href="#index" className="block text-xs text-background-50/50 hover:text-primary-400 transition-colors duration-150 whitespace-nowrap cursor-pointer">短视频创作</a>
              <a href="#index" className="block text-xs text-background-50/50 hover:text-primary-400 transition-colors duration-150 whitespace-nowrap cursor-pointer">纪录片频道</a>
            </div>
          </div>

          {/* Partners */}
          <div>
            <h3 className="font-medium text-background-50 text-sm mb-4">合作伙伴</h3>
            <p className="text-xs text-background-50/40 leading-relaxed">
              榴莲视频与多家优质内容平台保持良好合作关系，持续为用户提供丰富的视频资源。
            </p>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-background-50/10">
        <div className="max-w-7xl mx-auto px-4 md:px-6 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-50/40">
            &copy; 2026 榴莲视频 Liulian-SP.com 版权所有
          </p>
          <div className="flex items-center gap-4">
            <span className="text-xs text-background-50/40 cursor-pointer hover:text-primary-400 transition-colors duration-150">用户协议</span>
            <span className="text-xs text-background-50/40 cursor-pointer hover:text-primary-400 transition-colors duration-150">隐私政策</span>
            <span className="text-xs text-background-50/40 cursor-pointer hover:text-primary-400 transition-colors duration-150">免责声明</span>
          </div>
        </div>
      </div>
    </footer>
  );
}